import Component from 'flarum/common/Component';
import flag from '../../common/utils/flag';
export default class LanguageDisplay extends Component {
  view() {
    const {
      language,
      uppercase
    } = this.attrs;
    const name = language.name() || '';
    return m("span", null, flag(language), " ", uppercase ? name.toUpperCase() : name);
  }
}
flarum.reg.add('fof-discussion-language', 'forum/components/LanguageDisplay', LanguageDisplay);